import cx from 'classnames'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { PostType } from 'lib/_types'

import './style.scss'

type Props = {
  text?: string
  postType?: PostType
  color?: 'gray'
}

export const ActivityPostPreview = ({ color, postType, text }: Props) => {
  const { t } = useTranslation()

  const detail = useMemo(() => {
    switch (postType) {
      case 'image':
        return (
          <>
            <img
              className="ActivitiesList__item__postPreview__attachment__icon"
              src="/images/icon-postbox-image.svg"
            />
            <span>{t('activity_list.preview.image')}</span>
          </>
        )

      case 'video':
        return (
          <>
            <img
              className="ActivitiesList__item__postPreview__attachment__icon"
              src="/images/icon-video.svg"
            />
            <span>{t('activity_list.preview.video')}</span>
          </>
        )

      case 'survey':
        return (
          <>
            <img
              className="ActivitiesList__item__postPreview__attachment__icon"
              src="/images/icon-postbox-list.svg"
            />
            <span>{t('activity_list.preview.survey')}</span>
          </>
        )

      default:
        return null
    }
  }, [postType])

  if (!text && !postType) return null
  return (
    <div
      className={cx('ActivitiesList__item__postPreview', {
        'ActivitiesList__item__postPreview--gray': color === 'gray',
      })}
    >
      <div className="ActivitiesList__item__postPreview__text">{text}</div>
      <div className="ActivitiesList__item__postPreview__attachment">
        {detail}
      </div>
    </div>
  )
}
